(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var INTERVAL = 3500;

  function initSlider(ul) {
    var host = ul.closest('slider-component') || ul;
    var timer = null;

    function step() {
      var slide = ul.querySelector('.slider__slide');
      if (!slide) return;
      var gap = parseFloat(getComputedStyle(ul).columnGap) || 0;
      var delta = slide.getBoundingClientRect().width + gap;
      var maxScroll = ul.scrollWidth - ul.clientWidth;
      if (ul.scrollLeft >= maxScroll - 2) {
        ul.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        ul.scrollBy({ left: delta, behavior: 'smooth' });
      }
    }

    function start() { if (!timer) timer = setInterval(step, INTERVAL); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    ['pointerdown', 'touchstart', 'mouseenter', 'focusin'].forEach(function (ev) {
      host.addEventListener(ev, stop, { passive: true });
    });
    ['mouseleave', 'touchend', 'focusout'].forEach(function (ev) {
      host.addEventListener(ev, start, { passive: true });
    });
    start();
  }

  function boot() {
    document
      .querySelectorAll('[id^="Slider-"].product-grid.slider--tablet')
      .forEach(initSlider);
  }

  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
